export default "__VITE_ASSET__KPeGxEfJ__"